import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  // 🔥 CRITICAL: Tells the browser to save and send cookies automatically
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers["X-API-Key"] = "123456";
  return config;
});

// Fixed nested interceptor bug
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // ✅ IGNORE if already on login page
    if (window.location.pathname === "/") {
      return Promise.reject(error);
    }

    if (error?.response?.status === 401) {
      window.location.replace("/");
    }

    return Promise.reject(error);
  }
);

export default api;